import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Expand = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M9.338 1.333v1.334h3.059L9.533 5.529l.944.942 2.855-2.854v3.05h1.335V1.333H9.338ZM6.662 13.334v1.333H1.333V9.333h1.334v3.05l2.856-2.854.943.943-2.863 2.862h3.059Z"
      fill="currentColor"
    />
  </Icon>
));

export default Expand;
